module.exports = __webpack_public_path__ + "img/a1.ccb7a564.png";